/**** MH Custom JavaScript File ****/

document.addEventListener("scroll", function () {
  const header = document.querySelector(".stickyheader");

  if (!header) return;

  if (window.scrollY > 50) {
    header.classList.add("hsticky");
  } else {
    header.classList.remove("hsticky");
  }
});
